import type { GiftPassBundlePreviewResponse } from '@bonsai/shared';

import { BundleCostTable } from './BundleCostTable';

import './gift-pass-bundle-editor.css';

export interface BundleCostPreviewProps {
  /** False while the pass count or discount is not valid yet. */
  ready: boolean;
  preview: GiftPassBundlePreviewResponse | undefined;
  /** The prices shown are being replaced by ones for the current terms. */
  loading: boolean;
  /** Why the prices could not be loaded, if they could not. */
  failure: string | null;
}

export function BundleCostPreview({ ready, preview, loading, failure }: BundleCostPreviewProps) {
  let body;
  if (!ready) {
    body = <p className="gpb-ed-side-note">Enter a valid pass count and discount.</p>;
  } else if (preview) {
    body = <BundleCostTable preview={preview} loading={loading} />;
  } else if (failure) {
    body = <p className="gpb-ed-warn">{failure}</p>;
  } else {
    body = <p className="gpb-ed-side-note">Working out today’s prices…</p>;
  }
  return (
    <section className="nb-card gpb-ed-side-card" aria-labelledby="bundle-cost-title">
      <h2 id="bundle-cost-title" className="nb-eyebrow gpb-ed-side-title">
        Cost at today’s prices
      </h2>
      {body}
    </section>
  );
}
